export const PRE_OFFER_VERIFICATION_DOCUMENTS =
  "preoffer_verification_documents";
export const DOCUMENT_LIST = "documentList";
